import type { Country, CountryCode } from '~/types';

export const COUNTRIES: Record<CountryCode, Country> = {
  USA: {
    code: 'USA',
    name: 'United States',
    flag: '🇺🇸',
    colors: {
      primary: '#3C3B6E',
      secondary: '#B22234',
      tertiary: '#FFFFFF',
    },
    tagline: 'Classic American sports bars across NYC and North Jersey',
    neighborhoods: [
      "Hell's Kitchen, Manhattan",
      'Hoboken, NJ',
      'Williamsburg, Brooklyn',
      'Astoria, Queens',
      'Jersey City, NJ',
    ],
    venues: [
      {
        name: 'Smithfield Hall',
        type: 'Sports Bar',
        hood: "Hell's Kitchen",
        distance: '0.8 mi',
        rsvps: 91,
        friends: 4,
        photo: 'smithfield',
        lat: 40.7567,
        lng: -73.9935,
      },
      {
        name: 'Standings',
        type: 'Sports Bar',
        hood: 'East Village',
        distance: '1.4 mi',
        rsvps: 47,
        friends: 2,
        photo: 'standings',
        lat: 40.7296,
        lng: -73.9867,
      },
      {
        name: 'Texas Arizona',
        type: 'Sports Bar',
        hood: 'Hoboken',
        distance: '2.4 mi',
        rsvps: 53,
        friends: 2,
        photo: 'texas',
        lat: 40.7424,
        lng: -74.0258,
      },
      {
        name: 'Hudson Hall',
        type: 'Beer Hall',
        hood: 'Jersey City',
        distance: '5.8 mi',
        rsvps: 66,
        friends: 3,
        photo: 'hudsonhall',
        lat: 40.7191,
        lng: -74.0435,
      },
      {
        name: 'Roebling Sporting Club',
        type: 'Bar & Grill',
        hood: 'Williamsburg',
        distance: '4.1 mi',
        rsvps: 37,
        friends: 1,
        photo: 'roebling',
        lat: 40.7171,
        lng: -73.9583,
      },
    ],
  },

  BRA: {
    code: 'BRA',
    name: 'Brazil',
    flag: '🇧🇷',
    colors: {
      primary: '#009C3B',
      secondary: '#FFDF00',
      tertiary: '#002776',
    },
    tagline: 'Astoria and Ironbound bring heavy Brazil match energy',
    neighborhoods: [
      'Astoria, Queens',
      'Ironbound, Newark',
      'Long Branch, NJ',
      'Kearny, NJ',
      'Mineola, NY',
    ],
    venues: [
      {
        name: 'Favela Grill',
        type: 'Brazilian Steakhouse',
        hood: 'Astoria',
        distance: '2.1 mi',
        rsvps: 144,
        friends: 6,
        photo: 'favela',
        lat: 40.7642,
        lng: -73.9275,
      },
      {
        name: 'Berimbau Brazilian Kitchen',
        type: 'Brazilian Restaurant',
        hood: 'West Village',
        distance: '1.3 mi',
        rsvps: 82,
        friends: 3,
        photo: 'berimbau',
        lat: 40.7316,
        lng: -74.0031,
      },
      {
        name: 'Altas Horas Lanches',
        type: 'Brazilian Café',
        hood: 'Ironbound, Newark',
        distance: '9.2 mi',
        rsvps: 186,
        friends: 5,
        photo: 'altas',
        lat: 40.7298,
        lng: -74.1559,
      },
      {
        name: 'Brasilia Grill',
        type: 'Churrascaria',
        hood: 'Kearny',
        distance: '11 mi',
        rsvps: 94,
        friends: 2,
        photo: 'brasilia',
        lat: 40.7684,
        lng: -74.1452,
      },
      {
        name: 'Mambos Cafe',
        type: 'Brazilian Restaurant & Bar',
        hood: 'Long Branch',
        distance: '47 mi',
        rsvps: 42,
        friends: 1,
        photo: 'mambos',
        lat: 40.3045,
        lng: -73.9887,
      },
    ],
  },

  ARG: {
    code: 'ARG',
    name: 'Argentina',
    flag: '🇦🇷',
    colors: {
      primary: '#74ACDF',
      secondary: '#FFFFFF',
      tertiary: '#F6B40E',
    },
    tagline: 'Argentine steakhouses and fútbol culture all over Queens and Manhattan',
    neighborhoods: [
      'Jackson Heights, Queens',
      'East Village, Manhattan',
      'Bergenfield, NJ',
      'Astoria, Queens',
      'Long Island City, Queens',
    ],
    venues: [
      {
        name: 'Buenos Aires Restaurant',
        type: 'Argentine Steakhouse',
        hood: 'East Village',
        distance: '1.3 mi',
        rsvps: 129,
        friends: 5,
        photo: 'baires',
        lat: 40.7265,
        lng: -73.9836,
      },
      {
        name: 'La Fusta',
        type: 'Parrilla',
        hood: 'Bergenfield',
        distance: '12 mi',
        rsvps: 87,
        friends: 3,
        photo: 'fusta',
        lat: 40.9258,
        lng: -73.9981,
      },
      {
        name: 'Balvanera',
        type: 'Argentine Restaurant',
        hood: 'Lower East Side',
        distance: '1.7 mi',
        rsvps: 64,
        friends: 2,
        photo: 'balvanera',
        lat: 40.7213,
        lng: -73.9872,
      },
      {
        name: 'Libertador',
        type: 'Argentine Bakery & Café',
        hood: 'Queens',
        distance: '4.5 mi',
        rsvps: 52,
        friends: 1,
        photo: 'libertador',
        lat: 40.7477,
        lng: -73.8892,
      },
      {
        name: 'Baires Grill',
        type: 'Steakhouse',
        hood: 'Long Island City',
        distance: '3.7 mi',
        rsvps: 74,
        friends: 2,
        photo: 'bairesgrill',
        lat: 40.7471,
        lng: -73.9498,
      },
    ],
  },

  FRA: {
    code: 'FRA',
    name: 'France',
    flag: '🇫🇷',
    colors: {
      primary: '#0055A4',
      secondary: '#FFFFFF',
      tertiary: '#EF4135',
    },
    tagline: 'French cafés, wine bars, and brasseries downtown',
    neighborhoods: [
      'West Village, Manhattan',
      'SoHo, Manhattan',
      'Tribeca, Manhattan',
      'Upper East Side, Manhattan',
      'Montclair, NJ',
    ],
    venues: [
      {
        name: 'Buvette',
        type: 'French Bistro',
        hood: 'West Village',
        distance: '1.0 mi',
        rsvps: 66,
        friends: 3,
        photo: 'buvette',
        lat: 40.7328,
        lng: -74.0046,
      },
      {
        name: 'La Compagnie des Vins Surnaturels',
        type: 'Wine Bar',
        hood: 'SoHo',
        distance: '1.7 mi',
        rsvps: 39,
        friends: 1,
        photo: 'compagnie',
        lat: 40.7249,
        lng: -74.0001,
      },
      {
        name: 'Le Coucou',
        type: 'French Restaurant',
        hood: 'SoHo',
        distance: '1.8 mi',
        rsvps: 58,
        friends: 2,
        photo: 'lecoucou',
        lat: 40.7193,
        lng: -74.0007,
      },
      {
        name: 'Felix Roasting Co.',
        type: 'French-style Café',
        hood: 'SoHo',
        distance: '1.5 mi',
        rsvps: 44,
        friends: 1,
        photo: 'felix',
        lat: 40.7235,
        lng: -73.9988,
      },
      {
        name: 'Faubourg',
        type: 'French Brasserie',
        hood: 'Montclair',
        distance: '15 mi',
        rsvps: 27,
        friends: 1,
        photo: 'faubourg',
        lat: 40.8145,
        lng: -74.2162,
      },
    ],
  },

  POR: {
    code: 'POR',
    name: 'Portugal',
    flag: '🇵🇹',
    colors: {
      primary: '#046A38',
      secondary: '#DA291C',
      tertiary: '#FFD200',
    },
    tagline: 'Ironbound feels like Lisbon during Portugal matches',
    neighborhoods: [
      'Ironbound, Newark',
      'Elizabeth, NJ',
      'Mineola, NY',
      'Kearny, NJ',
      'Belleville, NJ',
    ],
    venues: [
      {
        name: 'Sol-Mar Restaurant',
        type: 'Portuguese Seafood',
        hood: 'Ironbound, Newark',
        distance: '8.9 mi',
        rsvps: 224,
        friends: 9,
        photo: 'solmar',
        lat: 40.7289,
        lng: -74.1548,
      },
      {
        name: 'Seabra’s Marisqueira',
        type: 'Marisqueira',
        hood: 'Ironbound, Newark',
        distance: '9.1 mi',
        rsvps: 191,
        friends: 6,
        photo: 'seabras',
        lat: 40.7304,
        lng: -74.1571,
      },
      {
        name: 'Valença Restaurant',
        type: 'Portuguese Grill',
        hood: 'Elizabeth',
        distance: '14 mi',
        rsvps: 112,
        friends: 4,
        photo: 'valenca',
        lat: 40.6647,
        lng: -74.2105,
      },
      {
        name: 'Adega Grill',
        type: 'Portuguese Steakhouse',
        hood: 'Ironbound, Newark',
        distance: '8.8 mi',
        rsvps: 133,
        friends: 5,
        photo: 'adega',
        lat: 40.7282,
        lng: -74.1588,
      },
      {
        name: 'Fernandes Steak House',
        type: 'Rodizio',
        hood: 'Newark',
        distance: '9.4 mi',
        rsvps: 118,
        friends: 3,
        photo: 'fernandes',
        lat: 40.7364,
        lng: -74.1694,
      },
    ],
  },

  ECU: {
    code: 'ECU',
    name: 'Ecuador',
    flag: '🇪🇨',
    colors: {
      primary: '#FFD100',
      secondary: '#0072CE',
      tertiary: '#EF3340',
    },
    tagline: 'Corona and Jackson Heights go crazy for Ecuador games',
    neighborhoods: [
      'Corona, Queens',
      'Jackson Heights, Queens',
      'Newark, NJ',
      'Passaic, NJ',
      'Elmhurst, Queens',
    ],
    venues: [
      {
        name: "Leticia's",
        type: 'Ecuadorian Restaurant',
        hood: 'Corona',
        distance: '5.3 mi',
        rsvps: 138,
        friends: 5,
        photo: 'leticias',
        lat: 40.7498,
        lng: -73.8646,
      },
      {
        name: 'Nuevo Don Francisco Restaurant',
        type: 'Ecuadorian Restaurant',
        hood: 'Corona',
        distance: '5.4 mi',
        rsvps: 92,
        friends: 2,
        photo: 'donfrancisco',
        lat: 40.7496,
        lng: -73.8692,
      },
      {
        name: 'La Boina Roja',
        type: 'Ecuadorian & Colombian Restaurant',
        hood: 'Jackson Heights',
        distance: '4.7 mi',
        rsvps: 81,
        friends: 2,
        photo: 'boina',
        lat: 40.7488,
        lng: -73.8916,
      },
      {
        name: 'Ecuatoriana Restaurant',
        type: 'Ecuadorian Restaurant',
        hood: 'Passaic',
        distance: '13 mi',
        rsvps: 57,
        friends: 1,
        photo: 'ecuatoriana',
        lat: 40.8564,
        lng: -74.1268,
      },
      {
        name: 'Rincón Melania',
        type: 'Ecuadorian Restaurant',
        hood: 'Elmhurst',
        distance: '5.1 mi',
        rsvps: 64,
        friends: 2,
        photo: 'melania',
        lat: 40.7428,
        lng: -73.8829,
      },
    ],
  },

  MEX: {
    code: 'MEX',
    name: 'Mexico',
    flag: '🇲🇽',
    colors: {
      primary: '#006847',
      secondary: '#FFFFFF',
      tertiary: '#CE1126',
    },
    tagline: 'Sunset Park and Passaic turn green-white-red',
    neighborhoods: [
      'Sunset Park, Brooklyn',
      'Passaic, NJ',
      'East Harlem, Manhattan',
      'Bushwick, Brooklyn',
      'Corona, Queens',
    ],
    venues: [
      {
        name: 'Zona Rosa',
        type: 'Mexican Bar & Grill',
        hood: 'Sunset Park',
        distance: '6.1 mi',
        rsvps: 201,
        friends: 7,
        photo: 'zonarosa',
        lat: 40.6489,
        lng: -74.0057,
      },
      {
        name: 'Taqueria Los Gueros',
        type: 'Taqueria',
        hood: 'Passaic',
        distance: '13 mi',
        rsvps: 104,
        friends: 3,
        photo: 'gueros',
        lat: 40.8566,
        lng: -74.1281,
      },
      {
        name: 'Cantina Rooftop',
        type: 'Cantina',
        hood: "Hell's Kitchen",
        distance: '1.5 mi',
        rsvps: 145,
        friends: 5,
        photo: 'cantina',
        lat: 40.7607,
        lng: -73.9916,
      },
      {
        name: 'Casa Enrique',
        type: 'Mexican Restaurant',
        hood: 'Long Island City',
        distance: '3.8 mi',
        rsvps: 71,
        friends: 2,
        photo: 'enrique',
        lat: 40.7191,
        lng: -73.9573,
      },
      {
        name: 'Los Tacos No. 1',
        type: 'Taqueria',
        hood: 'Chelsea',
        distance: '1.9 mi',
        rsvps: 133,
        friends: 4,
        photo: 'lostacos',
        lat: 40.7429,
        lng: -74.0060,
      },
    ],
  },

  COL: {
    code: 'COL',
    name: 'Colombia',
    flag: '🇨🇴',
    colors: {
      primary: '#FCD116',
      secondary: '#003893',
      tertiary: '#CE1126',
    },
    tagline: 'Queens and Elizabeth stay loud for Colombia matches',
    neighborhoods: [
      'Jackson Heights, Queens',
      'Elizabeth, NJ',
      'Sunnyside, Queens',
      'Hackensack, NJ',
      'Corona, Queens',
    ],
    venues: [
      {
        name: 'Noches de Colombia',
        type: 'Restaurant & Bakery',
        hood: 'Elizabeth',
        distance: '14 mi',
        rsvps: 118,
        friends: 4,
        photo: 'noches',
        lat: 40.6634,
        lng: -74.2109,
      },
      {
        name: 'Arepa Lady',
        type: 'Arepera',
        hood: 'Jackson Heights',
        distance: '4.6 mi',
        rsvps: 97,
        friends: 3,
        photo: 'arepa',
        lat: 40.7494,
        lng: -73.8915,
      },
      {
        name: 'La Pequeña Colombia',
        type: 'Colombian Restaurant',
        hood: 'Hackensack',
        distance: '15 mi',
        rsvps: 83,
        friends: 2,
        photo: 'pequena',
        lat: 40.8857,
        lng: -74.0431,
      },
      {
        name: 'Brisas del Caribe',
        type: 'Colombian Restaurant',
        hood: 'Corona',
        distance: '5.4 mi',
        rsvps: 76,
        friends: 2,
        photo: 'brisas',
        lat: 40.7486,
        lng: -73.8674,
      },
      {
        name: 'Mis Tierras Colombianas',
        type: 'Restaurant & Bar',
        hood: 'Queens',
        distance: '4.9 mi',
        rsvps: 69,
        friends: 2,
        photo: 'mistierras',
        lat: 40.7471,
        lng: -73.8908,
      },
    ],
  },

  KOR: {
    code: 'KOR',
    name: 'South Korea',
    flag: '🇰🇷',
    colors: { primary: '#CD2E3A', secondary: '#0047A0', tertiary: '#FFFFFF' },
    tagline: 'K-Town and Palisades Park run the Reds Devils show',
    neighborhoods: ['K-Town, Manhattan', 'Palisades Park, NJ', 'Flushing, Queens'],
    venues: [
      { name: 'Pocha Tab', type: 'Pocha · Soju Bar', hood: 'K-Town', distance: '0.6 mi', rsvps: 134, friends: 5, photo: 'pocha', lat: 40.7475, lng: -73.9854 },
      { name: 'Banchan Bar', type: 'Korean Sports Bar', hood: 'Palisades Park, NJ', distance: '12 mi', rsvps: 88, friends: 3, photo: 'banchan', lat: 40.8466, lng: -73.9968 },
      { name: 'Soju & Karaoke', type: 'Karaoke Bar', hood: 'Flushing', distance: '7.3 mi', rsvps: 67, friends: 2, photo: 'soju', lat: 40.7593, lng: -73.8307 },
    ],
  },

  CRO: {
    code: 'CRO',
    name: 'Croatia',
    flag: '🇭🇷',
    colors: { primary: '#FF0000', secondary: '#FFFFFF', tertiary: '#171796' },
    tagline: "Bayonne keeps the Vatreni faith — and the burek",
    neighborhoods: ['Bayonne, NJ', 'Astoria, Queens', "Hell's Kitchen, Manhattan"],
    venues: [
      { name: 'Croatian Hall', type: 'Social Club · Restaurant', hood: 'Bayonne', distance: '12 mi', rsvps: 91, friends: 4, photo: 'crohall', lat: 40.6687, lng: -74.1143 },
      { name: 'Konoba Astoria', type: 'Konoba · Grilled Meats', hood: 'Astoria', distance: '4.4 mi', rsvps: 64, friends: 2, photo: 'konoba', lat: 40.7644, lng: -73.9145 },
      { name: 'Vatreni Pub', type: 'Sports Bar', hood: "Hell's Kitchen", distance: '0.7 mi', rsvps: 53, friends: 2, photo: 'vatreni', lat: 40.7600, lng: -73.9920 },
    ],
  },

  JPN: {
    code: 'JPN',
    name: 'Japan',
    flag: '🇯🇵',
    colors: { primary: '#BC002D', secondary: '#FFFFFF', tertiary: '#BC002D' },
    tagline: 'Little Tokyo and Edgewater turn out for Samurai Blue',
    neighborhoods: ['East Village, Manhattan', 'Edgewater, NJ', 'Mamaroneck, NY'],
    venues: [
      { name: 'Sake Bar Decibel', type: 'Sake Bar · Izakaya', hood: 'East Village', distance: '1.3 mi', rsvps: 86, friends: 4, photo: 'decibel', lat: 40.7280, lng: -73.9871 },
      { name: 'Mitsuwa Marketplace', type: 'Japanese Food Court', hood: 'Edgewater, NJ', distance: '8.7 mi', rsvps: 48, friends: 1, photo: 'mitsuwa', lat: 40.8154, lng: -73.9748 },
      { name: 'Izakaya Setagaya', type: 'Izakaya · Ramen', hood: 'Mamaroneck, NY', distance: '24 mi', rsvps: 32, friends: 1, photo: 'setagaya', lat: 40.9477, lng: -73.7320 },
    ],
  },

  ENG: {
    code: 'ENG',
    name: 'England',
    flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
    colors: { primary: '#CF142B', secondary: '#FFFFFF', tertiary: '#CF142B' },
    tagline: "Park Slope and Cobble Hill turn into pub central",
    neighborhoods: ['Park Slope, Brooklyn', 'Cobble Hill, Brooklyn', 'West Village, Manhattan'],
    venues: [
      { name: 'The Spotted Pig', type: 'Gastropub', hood: 'West Village', distance: '1.1 mi', rsvps: 124, friends: 5, photo: 'spotted', lat: 40.7333, lng: -74.0055 },
      { name: 'The Black Sheep', type: 'British Pub', hood: 'Cobble Hill', distance: '3.6 mi', rsvps: 86, friends: 3, photo: 'blacksheep', lat: 40.6857, lng: -73.9954 },
      { name: 'The Crown', type: 'Pub · Sports Bar', hood: 'Park Slope', distance: '4.2 mi', rsvps: 102, friends: 4, photo: 'crown', lat: 40.6760, lng: -73.9810 },
    ],
  },

  SEN: {
    code: 'SEN',
    name: 'Senegal',
    flag: '🇸🇳',
    colors: { primary: '#00853F', secondary: '#FDEF42', tertiary: '#E31B23' },
    tagline: "Le Petit Senegal turns 116th Street into Dakar",
    neighborhoods: ['West Harlem, Manhattan', 'East Bronx', 'Bed-Stuy, Brooklyn'],
    venues: [
      { name: 'La Savane', type: 'Senegalese Restaurant', hood: 'West Harlem', distance: '5.1 mi', rsvps: 112, friends: 4, photo: 'savane', lat: 40.8053, lng: -73.9499 },
      { name: 'African Kine', type: 'Restaurant · Lounge', hood: 'West Harlem', distance: '4.9 mi', rsvps: 78, friends: 3, photo: 'kine', lat: 40.7990, lng: -73.9518 },
      { name: 'Le Baobab', type: 'Café · Lounge', hood: 'East Bronx', distance: '8.3 mi', rsvps: 51, friends: 2, photo: 'baobab', lat: 40.8295, lng: -73.9182 },
    ],
  },

  GER: {
    code: 'GER',
    name: 'Germany',
    flag: '🇩🇪',
    colors: { primary: '#000000', secondary: '#DD0000', tertiary: '#FFCC00' },
    tagline: 'Yorkville lager halls and Whippany still pull the Mannschaft faithful',
    neighborhoods: ['Yorkville, Manhattan', 'Glendale, Queens', 'Whippany, NJ'],
    venues: [
      { name: 'Heidelberg', type: 'Bavarian Restaurant', hood: 'Yorkville', distance: '3.0 mi', rsvps: 118, friends: 4, photo: 'heidelberg', lat: 40.7752, lng: -73.9520 },
      { name: 'Zum Stammtisch', type: 'German Tavern', hood: 'Glendale, Queens', distance: '10 mi', rsvps: 94, friends: 3, photo: 'stammtisch', lat: 40.7032, lng: -73.8638 },
      { name: 'Schmidts Restaurant', type: 'German Restaurant', hood: 'Whippany, NJ', distance: '22 mi', rsvps: 61, friends: 2, photo: 'schmidts', lat: 40.8217, lng: -74.4137 },
    ],
  },

  MAR: {
    code: 'MAR',
    name: 'Morocco',
    flag: '🇲🇦',
    colors: { primary: '#C1272D', secondary: '#FFFFFF', tertiary: '#006233' },
    tagline: 'Bay Ridge and Astoria pull the Atlas Lions crowd',
    neighborhoods: ['Bay Ridge, Brooklyn', 'East Village, Manhattan', "Hell's Kitchen, Manhattan"],
    venues: [
      { name: 'Café Mogador', type: 'Moroccan Café', hood: 'East Village', distance: '1.4 mi', rsvps: 147, friends: 5, photo: 'mogador', lat: 40.7280, lng: -73.9870 },
      { name: 'Tagine Dining Gallery', type: 'Moroccan Restaurant', hood: "Hell's Kitchen", distance: '0.8 mi', rsvps: 102, friends: 4, photo: 'tagine', lat: 40.7625, lng: -73.9881 },
      { name: 'Maroma', type: 'Moroccan Lounge', hood: 'Bay Ridge', distance: '9.0 mi', rsvps: 89, friends: 3, photo: 'maroma', lat: 40.6232, lng: -74.0287 },
    ],
  },

  // ─── Remaining 2026 World Cup nations ──────────────────────────────────
  // Sourced from the backend country seed. Venue/neighborhood coverage is
  // still being built out; `venues: []` renders a "coming soon" card.
  ESP: {
    code: 'ESP',
    name: 'Spain',
    flag: '🇪🇸',
    colors: { primary: '#AA151B', secondary: '#F1BF00', tertiary: '#AA151B' },
    tagline: '',
    neighborhoods: ['Chelsea, Manhattan'],
    venues: [],
  },
  NED: {
    code: 'NED',
    name: 'Netherlands',
    flag: '🇳🇱',
    colors: { primary: '#AE1C28', secondary: '#FFFFFF', tertiary: '#21468B' },
    tagline: '',
    neighborhoods: [],
    venues: [],
  },
  NOR: {
    code: 'NOR',
    name: 'Norway',
    flag: '🇳🇴',
    colors: { primary: '#BA0C2F', secondary: '#FFFFFF', tertiary: '#00205B' },
    tagline: '',
    neighborhoods: ['Bay Ridge, Brooklyn'],
    venues: [],
  },
  BEL: {
    code: 'BEL',
    name: 'Belgium',
    flag: '🇧🇪',
    colors: { primary: '#000000', secondary: '#FAE042', tertiary: '#ED2939' },
    tagline: '',
    neighborhoods: [],
    venues: [],
  },
  SUI: {
    code: 'SUI',
    name: 'Switzerland',
    flag: '🇨🇭',
    colors: { primary: '#DA291C', secondary: '#FFFFFF', tertiary: '#DA291C' },
    tagline: '',
    neighborhoods: [],
    venues: [],
  },
  URU: {
    code: 'URU',
    name: 'Uruguay',
    flag: '🇺🇾',
    colors: { primary: '#0038A8', secondary: '#FFFFFF', tertiary: '#FCD116' },
    tagline: '',
    neighborhoods: ['Jackson Heights, Queens', 'Elizabeth, NJ'],
    venues: [],
  },
  TUR: {
    code: 'TUR',
    name: 'Türkiye',
    flag: '🇹🇷',
    colors: { primary: '#E30A17', secondary: '#FFFFFF', tertiary: '#E30A17' },
    tagline: '',
    neighborhoods: ['Paterson, NJ', 'Sunnyside, Queens'],
    venues: [],
  },
  SWE: {
    code: 'SWE',
    name: 'Sweden',
    flag: '🇸🇪',
    colors: { primary: '#006AA7', secondary: '#FECC02', tertiary: '#006AA7' },
    tagline: '',
    neighborhoods: ['Cobble Hill, Brooklyn', 'Sunset Park, Brooklyn'],
    venues: [],
  },
  AUT: {
    code: 'AUT',
    name: 'Austria',
    flag: '🇦🇹',
    colors: { primary: '#ED2939', secondary: '#FFFFFF', tertiary: '#ED2939' },
    tagline: '',
    neighborhoods: ['Yorkville, Manhattan'],
    venues: [],
  },
  SCO: {
    code: 'SCO',
    name: 'Scotland',
    flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
    colors: { primary: '#005EB8', secondary: '#FFFFFF', tertiary: '#005EB8' },
    tagline: '',
    neighborhoods: ['Kearny, NJ'],
    venues: [],
  },
  CAN: {
    code: 'CAN',
    name: 'Canada',
    flag: '🇨🇦',
    colors: { primary: '#FF0000', secondary: '#FFFFFF', tertiary: '#FF0000' },
    tagline: '',
    neighborhoods: [],
    venues: [],
  },
  CZE: {
    code: 'CZE',
    name: 'Czechia',
    flag: '🇨🇿',
    colors: { primary: '#11457E', secondary: '#FFFFFF', tertiary: '#D7141A' },
    tagline: '',
    neighborhoods: ['Astoria, Queens', 'Yorkville, Manhattan'],
    venues: [],
  },
  CIV: {
    code: 'CIV',
    name: "Côte d'Ivoire",
    flag: '🇨🇮',
    colors: { primary: '#F77F00', secondary: '#FFFFFF', tertiary: '#009E60' },
    tagline: '',
    neighborhoods: ['Harlem, Manhattan', 'Mott Haven, Bronx'],
    venues: [],
  },
  GHA: {
    code: 'GHA',
    name: 'Ghana',
    flag: '🇬🇭',
    colors: { primary: '#CE1126', secondary: '#FCD116', tertiary: '#006B3F' },
    tagline: '',
    neighborhoods: ['Concourse, Bronx', 'Co-op City, Bronx'],
    venues: [],
  },
  EGY: {
    code: 'EGY',
    name: 'Egypt',
    flag: '🇪🇬',
    colors: { primary: '#CE1126', secondary: '#FFFFFF', tertiary: '#000000' },
    tagline: '',
    neighborhoods: ['Astoria, Queens'],
    venues: [],
  },
  PAR: {
    code: 'PAR',
    name: 'Paraguay',
    flag: '🇵🇾',
    colors: { primary: '#D52B1E', secondary: '#FFFFFF', tertiary: '#0038A8' },
    tagline: '',
    neighborhoods: ['Bound Brook, NJ'],
    venues: [],
  },
  ALG: {
    code: 'ALG',
    name: 'Algeria',
    flag: '🇩🇿',
    colors: { primary: '#006233', secondary: '#FFFFFF', tertiary: '#D21034' },
    tagline: 'Maghrebi pockets in Astoria and Bay Ridge',
    neighborhoods: ['Astoria, Queens', 'Bay Ridge, Brooklyn'],
    venues: [],
  },
  BIH: {
    code: 'BIH',
    name: 'Bosnia & Herzegovina',
    flag: '🇧🇦',
    colors: { primary: '#002F6C', secondary: '#FECB00', tertiary: '#FFFFFF' },
    tagline: '',
    neighborhoods: ['Astoria, Queens', 'Hackettstown, NJ'],
    venues: [],
  },
  AUS: {
    code: 'AUS',
    name: 'Australia',
    flag: '🇦🇺',
    colors: { primary: '#00008B', secondary: '#E4002B', tertiary: '#FFFFFF' },
    tagline: '',
    neighborhoods: ['Nolita, Manhattan', 'Tribeca, Manhattan'],
    venues: [],
  },
  TUN: {
    code: 'TUN',
    name: 'Tunisia',
    flag: '🇹🇳',
    colors: { primary: '#E70013', secondary: '#FFFFFF', tertiary: '#E70013' },
    tagline: '',
    neighborhoods: ['Astoria, Queens', 'Paterson, NJ'],
    venues: [],
  },
  IRN: {
    code: 'IRN',
    name: 'Iran',
    flag: '🇮🇷',
    colors: { primary: '#239F40', secondary: '#FFFFFF', tertiary: '#DA0000' },
    tagline: '',
    neighborhoods: ['Great Neck, NY'],
    venues: [],
  },
  COD: {
    code: 'COD',
    name: 'DR Congo',
    flag: '🇨🇩',
    colors: { primary: '#007FFF', secondary: '#F7D618', tertiary: '#CE1021' },
    tagline: 'Central African community in the Bronx and Harlem',
    neighborhoods: ['Concourse, Bronx', 'Harlem, Manhattan'],
    venues: [],
  },
  RSA: {
    code: 'RSA',
    name: 'South Africa',
    flag: '🇿🇦',
    colors: { primary: '#007749', secondary: '#FFB81C', tertiary: '#DE3831' },
    tagline: '',
    neighborhoods: [],
    venues: [],
  },
  CPV: {
    code: 'CPV',
    name: 'Cape Verde',
    flag: '🇨🇻',
    colors: { primary: '#003893', secondary: '#FFFFFF', tertiary: '#CF2027' },
    tagline: '',
    neighborhoods: ['Ironbound, Newark'],
    venues: [],
  },
  KSA: {
    code: 'KSA',
    name: 'Saudi Arabia',
    flag: '🇸🇦',
    colors: { primary: '#006C35', secondary: '#FFFFFF', tertiary: '#006C35' },
    tagline: '',
    neighborhoods: [],
    venues: [],
  },
  PAN: {
    code: 'PAN',
    name: 'Panama',
    flag: '🇵🇦',
    colors: { primary: '#DA121A', secondary: '#005293', tertiary: '#FFFFFF' },
    tagline: '',
    neighborhoods: ['Crown Heights, Brooklyn', 'Flatbush, Brooklyn'],
    venues: [],
  },
  UZB: {
    code: 'UZB',
    name: 'Uzbekistan',
    flag: '🇺🇿',
    colors: { primary: '#0099B5', secondary: '#FFFFFF', tertiary: '#1EB53A' },
    tagline: '',
    neighborhoods: ['Rego Park, Queens', 'Forest Hills, Queens'],
    venues: [],
  },
  QAT: {
    code: 'QAT',
    name: 'Qatar',
    flag: '🇶🇦',
    colors: { primary: '#8A1538', secondary: '#FFFFFF', tertiary: '#8A1538' },
    tagline: '',
    neighborhoods: [],
    venues: [],
  },
  NZL: {
    code: 'NZL',
    name: 'New Zealand',
    flag: '🇳🇿',
    colors: { primary: '#00247D', secondary: '#CC142B', tertiary: '#FFFFFF' },
    tagline: '',
    neighborhoods: [],
    venues: [],
  },
  IRQ: {
    code: 'IRQ',
    name: 'Iraq',
    flag: '🇮🇶',
    colors: { primary: '#CE1126', secondary: '#FFFFFF', tertiary: '#000000' },
    tagline: '',
    neighborhoods: ['Paterson, NJ'],
    venues: [],
  },
  HAI: {
    code: 'HAI',
    name: 'Haiti',
    flag: '🇭🇹',
    colors: { primary: '#00209F', secondary: '#D21034', tertiary: '#FFFFFF' },
    tagline: '',
    neighborhoods: ['Flatbush, Brooklyn', 'East Flatbush, Brooklyn'],
    venues: [],
  },
  CUW: {
    code: 'CUW',
    name: 'Curaçao',
    flag: '🇨🇼',
    colors: { primary: '#002B7F', secondary: '#F9E814', tertiary: '#FFFFFF' },
    tagline: '',
    neighborhoods: [],
    venues: [],
  },
  JOR: {
    code: 'JOR',
    name: 'Jordan',
    flag: '🇯🇴',
    colors: { primary: '#000000', secondary: '#FFFFFF', tertiary: '#007A3D' },
    tagline: '',
    neighborhoods: ['Paterson, NJ'],
    venues: [],
  },
};

// Curated countries (with venue data) first, then the rest of the field.
export const COUNTRY_ORDER: CountryCode[] = [
  'BRA',
  'ARG',
  'POR',
  'COL',
  'ECU',
  'MEX',
  'FRA',
  'USA',
  'KOR',
  'CRO',
  'JPN',
  'ENG',
  'SEN',
  'GER',
  'MAR',
  'ESP',
  'NED',
  'NOR',
  'BEL',
  'SUI',
  'URU',
  'TUR',
  'SWE',
  'AUT',
  'SCO',
  'CAN',
  'CZE',
  'CIV',
  'GHA',
  'EGY',
  'PAR',
  'ALG',
  'BIH',
  'AUS',
  'TUN',
  'IRN',
  'COD',
  'RSA',
  'CPV',
  'KSA',
  'PAN',
  'UZB',
  'QAT',
  'NZL',
  'IRQ',
  'HAI',
  'CUW',
  'JOR',
];

// NOTE: match + friend fixtures for the phone preview now live in
// src/landing/fixtures.ts, typed against the real app domain model.